var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.7987 46.5101H59.7987V35.5101L50.7987 21.5101H39.7987V46.5101H43.7987",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79871 46.5101H1.79867V14.5101H39.7987V46.5101H19.7987",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79867 41.5101H1.79867V43.5101H7.79867V41.5101Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7987 41.5101H21.7987V43.5101H39.7987V41.5101Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7986 41.5101H55.7987V43.5101H59.7986V41.5101Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7987 17.5101H4.79867V19.5101H39.7987V17.5101Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7987 51.5102C17.5602 51.5102 19.7988 49.2716 19.7988 46.5101C19.7988 43.7487 17.5602 41.5101 14.7987 41.5101C12.0373 41.5101 9.79871 43.7487 9.79871 46.5101C9.79871 49.2716 12.0373 51.5102 14.7987 51.5102Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7987 51.5102C51.5601 51.5102 53.7987 49.2716 53.7987 46.5101C53.7987 43.7487 51.5601 41.5101 48.7987 41.5101C46.0373 41.5101 43.7987 43.7487 43.7987 46.5101C43.7987 49.2716 46.0373 51.5102 48.7987 51.5102Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7987 45.5101H13.7987V47.5101H15.7987V45.5101Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7988 45.5101H47.7987V47.5101H49.7988V45.5101Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7987 9.51005H4.79867V11.5101H18.7987V9.51005Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79875 9.51005H0.798706V11.5101H2.79875V9.51005Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3687 25.5101H43.7987V34.5101H59.1587L53.3687 25.5101Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7987 21.51H39.7987V46.51H41.7987V21.51Z",
    fill: "#FFA83D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1587 34.5101L53.7287 26.0601C51.0597 29.2271 47.6486 31.6831 43.7987 33.2101V34.51H59.1587V34.5101Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6387 20.9701C51.4548 20.684 51.1387 20.511 50.7987 20.5101H40.7988V14.5101C40.7988 13.9581 40.3508 13.5101 39.7988 13.5101H1.79867C1.24671 13.5101 0.798706 13.9581 0.798706 14.5101V46.5101C0.798706 47.0621 1.24671 47.5101 1.79867 47.5101H8.88863C9.46062 50.7741 12.5696 52.9561 15.8336 52.3851C18.3226 51.949 20.2726 50.0001 20.7086 47.5101H42.8886C43.4606 50.7741 46.5696 52.9561 49.8336 52.3851C52.3225 51.949 54.2725 50.0001 54.7086 47.5101H59.7986C60.3506 47.5101 60.7986 47.0621 60.7986 46.5101V35.5101C60.7986 35.3181 60.7426 35.1311 60.6386 34.9701L51.6387 20.9701ZM52.7987 26.5101L57.3287 33.5101H44.7987V26.5101H52.7987ZM14.7987 50.5101C12.5898 50.5101 10.7988 48.7191 10.7988 46.5101C10.7988 44.3011 12.5898 42.5102 14.7987 42.5102C17.0077 42.5102 18.7987 44.3011 18.7987 46.5101C18.7987 48.7191 17.0077 50.5101 14.7987 50.5101ZM14.7987 40.5101C11.8727 40.5132 9.37671 42.6251 8.88875 45.5102H2.79875V43.5101H7.79878V41.5101H2.79875V15.5101H38.7987V17.5101H4.79867V19.5101H38.7986V41.5101H21.7987V43.5101H38.7987V45.5102H20.7087C20.2207 42.6261 17.7247 40.5131 14.7987 40.5101ZM48.7987 50.5101C46.5897 50.5101 44.7987 48.7191 44.7987 46.5101C44.7987 44.3011 46.5897 42.5102 48.7987 42.5102C51.0077 42.5102 52.7987 44.3011 52.7987 46.5101C52.7987 48.7191 51.0077 50.5101 48.7987 50.5101ZM54.7087 45.51C54.1367 42.246 51.0277 40.064 47.7637 40.635C45.2748 41.0711 43.3248 43.0201 42.8887 45.51H40.7987V22.5101H50.2487L51.5387 24.5102H43.7987C43.2467 24.5102 42.7987 24.9582 42.7987 25.5101V34.5101C42.7987 35.0621 43.2467 35.5101 43.7987 35.5101H58.6087L58.7987 35.8001V41.5101H55.7987V43.5101H58.7987V45.5102H54.7087V45.51Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7987 45.5101H13.7987V47.5101H15.7987V45.5101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7988 45.5101H47.7987V47.5101H49.7988V45.5101Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7987 9.51005H4.79867V11.5101H18.7987V9.51005Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.79875 9.51005H0.798706V11.5101H2.79875V9.51005Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0.798706 0.992981)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.eb7566937f59167d191d6cb64fdfc669.svg";
export { ForwardRef as ReactComponent };